/// <amd-module name="Wit/WorkItemForm/Links/GitHub/Components/PullRequestLinkState" />
import * as React from "react";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import { DefaultLinkTypeState } from "Wit/WorkItemLinksRegistration/Components";
import * as Resources from "Wit/WorkItemForm/Resources";
import { ExternalLinkedPullRequestArtifact } from "../GitHubDataProviderContracts";
import { GitHubPullReviewDecision } from "../../Constants";

export function PullRequestLinkState({ link }: { link: ILinkDisplayData }) {
    const pullRequest = link.additionalData?.pullRequest as ExternalLinkedPullRequestArtifact | undefined;
    if (!pullRequest?.reviewDecision) {
        return <DefaultLinkTypeState link={link} />;
    }

    if(pullRequest.isDraft) {
        return <span>• {Resources.GithubPullRequestDraft}</span>;
    }

    switch (pullRequest.reviewDecision.toLowerCase()) {
        case GitHubPullReviewDecision.Approved:
            return <span>• {Resources.GithubPullRequestReviewApproved}</span>;
        case GitHubPullReviewDecision.ReviewRequired:
            return <span>• {Resources.GithubPullRequestReviewRequired}</span>;
        case GitHubPullReviewDecision.ChangesRequested:
            return <span>• {Resources.GithubPullRequestChangesRequested}</span>;
    }
    return null;
}
